import { Pipe, PipeTransform } from '@angular/core';
import { IAppDataStore } from '@pershing/pershing-core';

@Pipe({
  name: 'accountDisplayPipe'
})
export class AccountDisplayPipe implements PipeTransform {
  private accountList: any;
  private acctdisplayformat: string;
  constructor(private appDataStore: IAppDataStore) {    
  }

  transform(accountNumber : string): string {
    this.accountList = this.appDataStore.get('ACCOUNTS_LIST');
    let acct ;
    if(this.accountList) {
      acct = this.accountList.find(c => c.acctNo === accountNumber);   
    }
    if (acct) {
      if(acct.acctNick) {
      this.acctdisplayformat = acct.acctNick +  '   x' + acct.displayLabel.substr(acct.displayLabel.length - 4);
    } else {
      this.acctdisplayformat = acct.maskedAcctNo;
    }                
      return this.acctdisplayformat;
    } else  {
      return accountNumber;
    }
    
  }

}
